module.exports = __webpack_public_path__ + "static/1-454e9467bdebb6d6d2e0d1eec8c159e5.jpg";